import { useContext, useEffect } from 'react'
import ModalSidebarContext from './ModalSidebarContext'

/**
 * Tells the surrounding ModalSidebar that its request is still processing after polling stopped,
 * so it closes without the unsaved-progress confirmation. Cleared when the caller unmounts or the value changes.
 */
function useReportStillProcessing(isStillProcessing) {
  const { setIsStillProcessing } = useContext(ModalSidebarContext)

  useEffect(() => {
    if (!isStillProcessing || !setIsStillProcessing) return undefined

    setIsStillProcessing(true)
    return () => setIsStillProcessing(false)
  }, [isStillProcessing, setIsStillProcessing])
}

export default useReportStillProcessing
